import React, { useState, useRef, useEffect } from "react";
import Nav from "./Nav";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function HeaderFour() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // header side collups area start here

  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("click", handleClickOutside);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // side menu active
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuVisible(!isMenuVisible);
    setIsOverlayVisible(!isOverlayVisible);
  };

  const handleCloseMenu = () => {
    setIsMenuVisible(false);
    setIsOverlayVisible(false);
  };

  const handleOverlayClick = () => {
    setIsMenuVisible(false);
    setIsOverlayVisible(false);
  };

  // mobile menu
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuhome) => {
    setOpenMenu(openMenu === menuhome ? null : menuhome);
  };

  return (
    <div>
      <header
        className={`tmp-header-area-start header-two header-four header-five header--sticky ${
          isSticky ? "sticky" : ""
        }`}
      >
        {/* header-top start */}
        <div className="header-top-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-top-inner">
                  <div className="left-information-area">
                    <p className="left-top">
                      <Link to={"tel:+8323510418"}>
                        <i className="fa-regular fa-phone" /> 832-351-0418
                      </Link>
                    </p>
                    <div className="location-area">
                      <i className="fa-light fa-location-dot" />
                      <Link
                        to="https://maps.app.goo.gl/DSKjbb24qTxyMEPE7"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        16314 Amber Brown Drive, Hockley, TX 77447
                      </Link>
                    </div>
                  </div>
                  <div className="right-header-top">
                    <div className="social-area-transparent">
                      <div className="bg-[#3B007A] flex space-x-8 p-4 text-white font-sans">
                        <a
                          href="/Business-Formation"
                          className="flex items-center space-x-2 hover:underline text-sm"
                        >
                          <span>
                            Business <strong>Formation</strong>
                          </span>
                          <ArrowRight size={16} color="white" />
                        </a>
                        <a
                          href="/business-consultation"
                          className="flex items-center space-x-2 hover:underline text-sm"
                        >
                          <span className="mr-5">
                            Business <strong>Consultation</strong>
                          </span>
                          <ArrowRight size={16} color="white" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* header-top end */}
        {/* header mid area start */}
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-mida-area style-two ">
                <div className="logo-area-start" style={{ width: "20%" }}>
                  <Link to="/">
                    <img
                      src="assets/images/logo/logo.png"
                      alt="logo"
                      
                    />
                  </Link>
                </div>
                <Nav />

                <div className="actions-area">
                  <Link to={"/contact-us"} className="tmp-btn btn-primary">
                    Free Consultation
                  </Link>
                  <div
                    className="tmp-side-collups-area"
                    id="side-collups"
                    onClick={handleMenuToggle}
                  >
                    <svg
                      width={20}
                      height={16}
                      viewBox="0 0 20 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect y={14} width={20} height={2} fill="#fff" />
                      <rect y={7} width={20} height={2} fill="#fff" />
                      <rect width={20} height={2} fill="#fff" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* header mid area end */}
      </header>

      <div id="side-hide" className={isMenuVisible ? "show" : ""}>
        <div className="top-area">
          <a href="/" className="logo-area">
            <img src="assets/images/logo/logo.png" alt="logo" />
          </a>
          <div className="close-icon-area">
            <div id="close-slide__main" onClick={handleOverlayClick}>
              <i className="fa-solid fa-x" />
            </div>
          </div>
        </div>

        {/* mobile menu area start */}
        <div className="mobile-menu-main">
          <nav className="nav-main mainmenu-nav mt--30">
            <ul className="mainmenu metismenu" id="mobile-menu-active">
              <li>
                <Link to="/" className="main" onClick={() => toggleMenu(1)}>
                  Home
                </Link>
               
              </li>

                <li>
                <Link to="/about" className="main" onClick={() => toggleMenu(1)}>
                  About
                </Link>
               
              </li>


              <li className="has-droupdown">
                            <Link className="main" to="/service" onClick={() => toggleMenu(1)}>
                                Service
                            </Link>
                            <ul className={`submenu ${openMenu === 1 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>

                                <li><Link to="/Business-Formation">  <img
                                    className="img-fluid me-3"
                          alt="Business Formation"
                          src="assets/images/services/business-formation.png"
                          style={{ width: "50px", height: "50px" }}
                        />  Business Formation</Link></li>

                                
                                <li><Link to="/payroll-management">  <img
                                    className="img-fluid me-3"
                          alt="Payroll Management"
                          src="assets/images/services/services-icon-2.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Payroll Management</Link></li>


                                <li><Link to="/book-keeping">  <img
                                    className="img-fluid me-3"
                          alt="Payroll Management"
                          src="assets/images/services/services-icon-3.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Book keeping</Link></li>


                                <li><Link to="/tax">  <img
                                    className="img-fluid me-3"
                          alt="Tax"
                          src="assets/images/services/tax.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Tax</Link></li>


                                  <li><Link to="/business-consultation">  <img
                                    className="img-fluid me-3"
                          alt="Business Consultations"
                          src="assets/images/services/business-consultation.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Business Consultations</Link></li>
                                

                            </ul>
                        </li>
                       
                        
                        <li>
                            <Link className="main" to="/contact-us">
                               Contact Us
                            </Link>
                        </li>

              
              
            </ul>
          </nav>
        </div>
        {/* mobile menu area end */}
      </div>

      <div
        id="overlay_every-where"
        className={isOverlayVisible ? "bgshow" : ""}
        onClick={handleOverlayClick}
      ></div>
    </div>
  );
}

export default HeaderFour;
